import { TokenStorage } from './../../../token.storage';
import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  OnChanges,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import MetisMenu from 'metismenujs/dist/metismenujs';

import { activateMenuItems, resetMenuItems } from './utils';
import { MENU } from './menu';
import { MenuItem } from './menu.model';
import { CheckUserType } from 'src/app/pages/model/checkUserType';
import { User } from 'src/app/core/models/auth.models';
import { MENU_COMPANY } from './companyMenu';
import { SUPER_USER } from './superUserMenu';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() isCondensed: boolean;
  @Input() mode: string;
  sidebarScrollRef: any;

  menu: any;

  timeIntevalSeconds = 60;
  user: User;
  checkUserType: CheckUserType;

  menuItems = [];
  suMenuItems = [];
  devMenuItems = [];
  @ViewChild('sideMenu', { static: false }) sideMenu: ElementRef;
  @ViewChild('authSideMenu', { static: false }) authSideMenu: ElementRef;
  @ViewChild('techSideMenu', { static: false }) techSideMenu: ElementRef;
  @ViewChild('devSideMenu', { static: false }) devSideMenu: ElementRef;


  constructor(
    router: Router,
    private token: TokenStorage
    ) {
      this.devMenuItems = MENU_COMPANY;
      this.suMenuItems = SUPER_USER;
      this.menuItems = MENU;
      this.user = new User();
      this.checkUserType = new CheckUserType();
      router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this._activateMenuDropdown();
      }
    });
  }

  ngOnInit() {
    let refreshIntervalId = setInterval(() => {
      if (this.token.getUserDetails() != null || this.token.getUserDetails() != undefined) {
        this.user = this.token.getUserDetails();
        this.initialize();
        clearInterval(refreshIntervalId);

       }
     }, this.timeIntevalSeconds * 1);

  }

  ngAfterViewInit() {
    // activate menu item
    this._initMenu();
  }

  /**
   * On prop change, look for layout settings
   */
  ngOnChanges() {
    if (!this.isCondensed && this.sideMenu || this.authSideMenu || this.techSideMenu ||  this.devSideMenu || this.isCondensed) {
      setTimeout(() => {
        this._initMenu();
      });
    } else if (this.menu) {
      this.menu.dispose();
    }
  }

  /**
   * Initizes metis menu
   */
  _initMenu() {
    if (this.checkUserType.checkUser(this.user.user_type) === 1) {
      if (this.mode === 'horizontal') {
      const menuRef = new MetisMenu(this.sideMenu.nativeElement).on('shown.metisMenu', (event) => {
        window.addEventListener('click', function menuClick(e) {
          if (!event.target.contains(e.target)) {
            menuRef.hide(event.detail.shownElement);
            window.removeEventListener('click', menuClick);
          }
        });
      });
    } else {
      this.menu = new MetisMenu(this.sideMenu.nativeElement);
    }
    } else if (this.checkUserType.checkUser(this.user.user_type) === 2) {
      if (this.mode === 'horizontal') {
        const menuRef = new MetisMenu(this.authSideMenu.nativeElement).on('shown.metisMenu', (event) => {
          window.addEventListener('click', function menuClick(e) {
            if (!event.target.contains(e.target)) {
              menuRef.hide(event.detail.shownElement);
              window.removeEventListener('click', menuClick);
            }
          });
        });
      } else {
        this.menu = new MetisMenu(this.authSideMenu.nativeElement);
      }
    } else if (this.checkUserType.checkUser(this.user.user_type) === 3) {
      if (this.mode === 'horizontal') {
        const menuRef = new MetisMenu(this.techSideMenu.nativeElement).on('shown.metisMenu', (event) => {
          window.addEventListener('click', function menuClick(e) {
            if (!event.target.contains(e.target)) {
              menuRef.hide(event.detail.shownElement);
              window.removeEventListener('click', menuClick);
            }
          });
        });
      } else {
        this.menu = new MetisMenu(this.techSideMenu.nativeElement);
      }
    } else if (this.checkUserType.checkUser(this.user.user_type) === 4) {
      if (this.mode === 'horizontal') {
        const menuRef = new MetisMenu(this.devSideMenu.nativeElement).on('shown.metisMenu', (event) => {
          window.addEventListener('click', function menuClick(e) {
            if (!event.target.contains(e.target)) {
              menuRef.hide(event.detail.shownElement);
              window.removeEventListener('click', menuClick);
            }
          });
        });
      } else {
        this.menu = new MetisMenu(this.devSideMenu.nativeElement);
      }
    }

    this._activateMenuDropdown();
  }

  /**
   * Activate the parent dropdown
   * TODO: This is hard-coded check - change to some common way
   */
  _activateMenuDropdown() {
    const activeClass = this.mode === 'horizontal' ? 'active' : 'mm-active';
    const dropdownActiveClass =
      this.mode === 'horizontal' ? 'active' : 'mm-show';

    resetMenuItems(activeClass, dropdownActiveClass);
    if (this.mode === 'horizontal') {
      resetMenuItems('mm-active', 'mm-show');
    }
    activateMenuItems(activeClass, dropdownActiveClass);
  }

  /**
   * Initilize
   */
  initialize() {
    this._initMenu();

  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  /**
   * Hides the menubar
   */
  hideMenu() {
    document.body.classList.remove('sidebar-enable');
  }
}
